import ItemFactory from "../actor/item/ItemFactory";
import QuestFetch from "./QuestFetch";

export default class QuestFillCollectionJar extends QuestFetch {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._jarEmpty = null;
        this._jarFull = null;

        this._itemCombined = false;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._jarEmpty = metadata.jarEmpty;
        this._jarFull = metadata.jarFull;
    }

    /**
     * @param {GameScene} game
     * @param {number} progress
     */
    onQuestProgress(game, progress) {
        super.onQuestProgress(game, progress);

        if (progress >= 1 && !this._itemCombined) {
            this._itemCombined = true;

            game.inventory.removeItem(this._item, this._target);
            game.inventory.removeItem(this._jarEmpty);
            game.inventory.addItem(this._jarFull);

            const temp = ItemFactory.create(this._jarFull);
            game.player.collectItem(temp, 1).then((icon) => game.hud.animateToInventory(icon));
            temp.destroy();

            game.questManager.completeQuest(this._id, this._owner);
            game.questManager.assignQuest(game.questManager.getCurrentQuestId(this._owner), this._owner);
        }
    }
}